define [], () ->
  ($resource, RENTAPPLICATION_API_URL) ->
    $resource(
      "#{RENTAPPLICATION_API_URL}/api/v1/application/:id/",
      {},
      {
        get:
          cache: true
        query:
          isArray: false
          cache: true
        update:
          url: "#{RENTAPPLICATION_API_URL}/api/v1/application/:id/"
          method: 'PATCH'
          params:
            id: "@id"
        change_owner:
          url: "#{RENTAPPLICATION_API_URL}/api/v1/application/:id/change_owner/"
          method: 'POST'
          params:
            id: "@id"
      }
    )



// WEBPACK FOOTER //
// ./resources/Application.coffee